(function () {
  if (!('ontouchstart' in window)) return;

  var startGallery = null;
  var activeGallery = null;

  function findProductCard(gallery) {
    return gallery && gallery.closest('product-card');
  }

  function fakeMouseEvent(pointerType) {
    return { pointerType: pointerType || 'mouse' };
  }

  function reveal(gallery) {
    if (!gallery || gallery === activeGallery) return;
    settle();
    var card = findProductCard(gallery);
    if (card && typeof card.previewImage === 'function') {
      card.previewImage(fakeMouseEvent());
      activeGallery = gallery;
    }
  }

  function settle() {
    if (!activeGallery) return;
    var card = findProductCard(activeGallery);
    if (card && typeof card.resetImage === 'function') {
      card.resetImage(fakeMouseEvent());
    }
    activeGallery = null;
  }

  document.addEventListener(
    'touchstart',
    function (event) {
      var touch = event.touches[0];
      if (!touch) return;
      var el = document.elementFromPoint(touch.clientX, touch.clientY);
      startGallery = el && el.closest('.card-gallery');
    },
    { passive: true }
  );

  document.addEventListener(
    'touchmove',
    function (event) {
      var touch = event.touches[0];
      if (!touch) return;

      var el = document.elementFromPoint(touch.clientX, touch.clientY);
      var gallery = el && el.closest('.card-gallery');

      // Only simulate a hover preview when the finger has scrolled onto a
      // *different* card than where the touch started — a deliberate swipe
      // on the starting card is left alone for the native carousel to handle.
      if (gallery && gallery !== startGallery) {
        reveal(gallery);
      } else if (activeGallery && gallery !== activeGallery) {
        settle();
      }
    },
    { passive: true }
  );

  document.addEventListener('touchend', settle, { passive: true });
  document.addEventListener('touchcancel', settle, { passive: true });
})();
